const timeZoneConverterTimeReducer = (state = { calendarDate: new Date(), sliderDot: 0 }, action) => {
  switch (action.type) {
    case 'TIME_ZONE_CONVERTER_TIME':
      return action.data;
    default:
      return state;
  }
};
  
export default timeZoneConverterTimeReducer;